import React from 'react';
import ReactDOM from 'react-dom';
import useSheet from 'app/jss';
import classNames from 'classnames';
import { TweenMax, Power3 } from 'gsap';

type Props = {
  classes: Object,
  selectedIndex?: number,
  children?: React$Element | Array<React$Element>,
  className?: string,
  scrollDelay?: number,
};

type State = {};

class CarouselScrollable extends React.Component {
  elements: Object = {};
  props: Props;
  state: State = {};

  static defaultProps = {
    selectedIndex: -1,
    children: undefined,
    className: undefined,
    scrollDelay: 0,
  };

  componentDidUpdate(prevProps: Props) {
    const { selectedIndex } = this.props;
    const isDifferent = prevProps.selectedIndex !== selectedIndex;
    if (isDifferent) {
      // this.scrollToElement(selectedIndex);
    }
  }

  scrollToElement = (index) => {
    // index might be -1, so assume that means the first element = 0
    const scrollElement = ReactDOM.findDOMNode(this.elements[Math.max(index, 0)]);
    if (this.carouselRef && scrollElement) {
      let offset = 10;
      if ((index + 1) === Object.keys(this.elements).length) {
        offset = -10;
      }
      TweenMax.to(this.carouselRef, 1, {
        scrollTo: { x: scrollElement, offsetX: offset },
        ease: Power3.easeInOut,
        // delay it a bit so it can animate in
        delay: this.props.scrollDelay,
      });
    }
  }

  setCarouselRef = (ref) => {
    this.carouselRef = ref;
  }

  render() {
    const {
      className,
      classes,
      children,
      selectedIndex,
    } = this.props;

    const scrollableChildren = React.Children.map(children, (child, index) =>
      React.cloneElement(child, {
        ...child.props,
        onRef: (node) => { this.elements[index] = node; },
        ref: (node) => {
          // 'Node' won't exist if the child is a functional component
          if (node) {
            this.elements[index] = node;
          }
          if (child.ref) { child.ref(node); }
        },
      }));

    return (
      <div
        className={classNames(className, classes.carouselScrollable, { closed: selectedIndex === -1 })}
        ref={this.setCarouselRef}
      >
        {scrollableChildren}
        {scrollableChildren.length !== 0 && <div className={classes.dodgyPaddingHack} />}
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    dodgyPaddingHack: {
      paddingLeft: 10,
    },
    carouselScrollable: {
      flexGrow: 1,
      display: 'inline-flex',
      overflowX: 'auto',
      overflowY: 'hidden',
      '-webkit-overflow-scrolling': 'touch',
      scrollSnapType: 'mandatory',
      scrollSnapPointsX: 'repeat(100%)',
      '&.closed': {
        width: '100%',
      },
    },
  };
}

export default useSheet(applyStyles)(CarouselScrollable);
